import { ChangeEvent, useEffect, useState } from 'react';

import {
  DialogComposite,
  FormTextField,
  extractLastNameComponent,
} from '@spotify/confidence-core-react';
import { AttachmentFragment } from '@spotify/confidence-graphql';
import { useUpdateAttachment } from '@spotify/plugin-confidence-attachments-react';

interface RenameArtifactDialogProps {
  artifact: AttachmentFragment;
  resolvedDisplayName?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const RenameArtifactDialog = ({
  artifact,
  resolvedDisplayName,
  open,
  onOpenChange,
}: RenameArtifactDialogProps) => {
  const currentName =
    artifact.displayName ||
    resolvedDisplayName ||
    extractLastNameComponent(artifact.uri);
  const [displayName, setDisplayName] = useState(currentName);

  useEffect(() => {
    if (open) {
      setDisplayName(currentName);
    }
  }, [open, currentName]);

  const { updateAttachment } = useUpdateAttachment({
    onError: 'post-alert',
  });

  const handleSubmit = async () => {
    await updateAttachment({ name: artifact.name, displayName }, [
      'displayName',
    ]);
  };

  const handleClose = () => {
    onOpenChange(false);
  };

  return (
    <DialogComposite.Root open={open} onClose={handleClose} width="sm">
      <DialogComposite.Content component="form" onSubmit={handleSubmit}>
        <DialogComposite.Header>
          <DialogComposite.Title>Rename</DialogComposite.Title>
        </DialogComposite.Header>
        <DialogComposite.Body>
          <DialogComposite.SubmitError />
          <FormTextField
            label="Name"
            value={displayName}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setDisplayName(e.target.value)
            }
            required
            autoFocus // eslint-disable-line jsx-a11y/no-autofocus
          />
        </DialogComposite.Body>
        <DialogComposite.Actions>
          <DialogComposite.Actions.Cancel />
          <DialogComposite.Actions.Submit>Save</DialogComposite.Actions.Submit>
        </DialogComposite.Actions>
      </DialogComposite.Content>
    </DialogComposite.Root>
  );
};
